import React from "react"

// redux
import { useSelector, useDispatch } from "react-redux"

// styles
import Styles from "./securityTab.module.css"

// icons
import { FiMail, FiSmartphone, FiShield, FiCheckCircle, FiXCircle } from "react-icons/fi"

// components
import Button from "../../../../components/Button/Button"
import { injectIntl } from "react-intl"
import GoogleAuthModal from "../../../modals/security/Enable2FAModal/Enable2FAModal"

// temp
import { showDisableSMSAuthModal } from "../../../modals/security/DisableSMSAuthModal/helpers"
import { showEnableSMSAuthModal } from "../../../modals/security/EnableSMSAuthModal/helpers"
import { showEnable2FAModal } from "../../../modals/security/Enable2FAModal/helpers"
import { showDisable2FAModal } from "../../../modals/security/Disable2FAModal/helpers"
import ResetPassword from "./ResetPassword"

function SecurityTab() {
  const dispatch = useDispatch()
  const exchangeName = useSelector((state) => state.exchangeCustomization.value.name)

  document.title = `${exchangeName}: Security`

  const modalOpen = useSelector((state) => state.Enable2FAModalState.open)
  const modalData = useSelector((state) => state.Enable2FAModalState.data)

  const userData = useSelector((state) => state.userData.value)
  const hasOtpLabel = userData?.otp
  const hasSMSAuth = userData?.sms_auth
  const isEmailVerified = userData?.labels?.some(
    (label) => label.key === "email" && label.value === "verified"
  )

  const securityFeatures = [
    {
      id: 'email',
      title: 'Email Authentication',
      description: "We'll send a digital bouncer to your inbox. Only VIPs allowed!",
      icon: FiMail,
      color: '#60a5fa',
      isActivated: isEmailVerified,
      showButton: false
    },
    {
      id: 'sms',
      title: 'SMS Authentication',
      description: "You'll hear a ding on your phone. It's just us, making sure it's you.",
      icon: FiSmartphone,
      color: '#10b981',
      isActivated: hasSMSAuth,
      showButton: true,
      onEnable: hasSMSAuth ? showDisableSMSAuthModal : showEnableSMSAuthModal,
      buttonText: hasSMSAuth ? "Disable" : "Enable"
    },
    {
      id: '2fa',
      title: 'Two-Factor Authenticator',
      description: 'Keep your account on lockdown, and only you hold the key.',
      icon: FiShield,
      color: '#ef4444',
      isActivated: hasOtpLabel,
      showButton: true,
      onEnable: hasOtpLabel ? showDisable2FAModal : showEnable2FAModal,
      buttonText: hasOtpLabel ? "Disable" : "Enable"
    }
  ]

  return (
    <div className={Styles.container}>
      <div className={Styles.card}>
        <div className={Styles.content}>
          <div className={Styles.modernSecurityContainer}>
            <h5>Security</h5>

            {/* Security Features */}
            <div className={Styles.securityFeatures}>
              {securityFeatures.map((feature) => {
                const Icon = feature.icon
                return (
                  <div key={feature.id} className={Styles.securityFeature}>
                    <div className={Styles.featureContent}>
                      <div className={Styles.featureIcon} style={{ backgroundColor: feature.color }}>
                        <Icon size={24} color="#ffffff" />
                      </div>

                      <div className={Styles.featureInfo}>
                        <h3 className={Styles.featureTitle}>{feature.title}</h3>
                        <p className={Styles.featureDescription}>{feature.description}</p>
                      </div>
                    </div>

                    <div className={Styles.featureActions}>
                      {/* Status */}
                      <div className={Styles.featureStatus}>
                        {feature.isActivated ? (
                          <>
                            <FiCheckCircle size={16} color="var(--success-color)" />
                            <span className={Styles.statusActivated}>ACTIVATED</span>
                          </>
                        ) : (
                          <>
                            <FiXCircle size={16} color="var(--danger-color)" />
                            <span className={Styles.statusDeactivated}>NOT ACTIVATED</span>
                          </>
                        )}
                      </div>

                      {/* Action Button */}
                      {feature.showButton && (
                        <Button
                          text={feature.buttonText}
                          variant={feature.isActivated ? "dark" : "primary"}
                          style={{
                            width: "100px",
                            height: "36px",
                            fontSize: "14px",
                            fontWeight: "600",
                            backgroundColor: feature.isActivated ? "var(--danger-color)" : "var(--primary-color)",
                            color: "#ffffff"
                          }}
                          onClick={feature.onEnable}
                        />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>

            {/* Password Section */}
            <div className={Styles.passwordSection}>
              <ResetPassword />
            </div>

            {modalOpen && <GoogleAuthModal />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default injectIntl(SecurityTab)
